import type { FC, HTMLAttributes } from 'react';

import { useModifiers } from '../../../../styles/hooks/useModifiers';

import styles from './AutoplayControlsLayout.module.css';

export interface AutoplayControlsContainerProps extends HTMLAttributes<HTMLDivElement> {
  hidden: boolean;
}

export const AutoplayControlsContainer: FC<AutoplayControlsContainerProps> = ({
  children,
  className,
  hidden,
  ...rest
}) => {
  const mods = useModifiers(styles, 'autoplayControls', { hidden }, { withBaseClass: true, extraClassName: className });

  return (
    <div className={mods} {...rest}>
      {children}
    </div>
  );
};

export const AutoplayControlsRow: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...rest }) => {
  const mods = useModifiers(styles, 'autoplayControls__row', {}, { withBaseClass: true, extraClassName: className });

  return (
    <div className={mods} {...rest}>
      {children}
    </div>
  );
};
